<template>
    <div class="content">
      <VocationIntroSection/>
      <VocationPersons1Section/>      
    </div>
  </template>
  
  <script lang="ts">
  import VocationIntroSection from '@/components/BrandPlataformPage/sections/vocation/VocationIntroSection.vue'
  import VocationPersons1Section from '@/components/BrandPlataformPage/sections/vocation/VocationPersons1Section.vue'  
  import { Component, Vue } from 'vue-property-decorator'
  
  @Component({
    components: {
      VocationIntroSection,
      VocationPersons1Section      
    }
  })
  export default class VocationView extends Vue {}
  </script>
  
  <style lang="scss"></style>
  